
import { FunctionComponent, useState } from 'react';
import MilitaryLandingContent from 'src/components/website/MilitaryLanding/MilitaryLandingContent';
import SurveyPopup, { SurveyResponse, SurveyResult } from 'src/components/website/MilitaryLanding/SurveyPopup';
import {
  MILITARY_CONSULTANTS,
  MilitaryConsultant,
  SurveySubmission,
} from 'src/constants/militaryLanding';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

// Randomizer preserved for future multi-consultant flow
// Currently only Ella is active in MILITARY_CONSULTANTS
// To reactivate: uncomment Frederique and Shondu in militaryLanding.ts
const selectRandomConsultant = (): MilitaryConsultant => {
  const index = Math.floor(Math.random() * MILITARY_CONSULTANTS.length);
  return MILITARY_CONSULTANTS[index];
};

const MilitaryLandingPage: FunctionComponent = () => {
  const [consultant] = useState<MilitaryConsultant>(selectRandomConsultant);
  const [surveyTriggered, setSurveyTriggered] = useState<boolean>(false);
  const [surveyComplete, setSurveyComplete] = useState<boolean>(false);
  const [visitorName, setVisitorName] = useState<string>('');
  const [surveyResponses, setSurveyResponses] = useState<ReadonlyArray<SurveyResponse>>([]);

  const handleConnectClick = (): void => {
    setSurveyTriggered(true);
  };

  const handleSurveyComplete = async (result: SurveyResult): Promise<void> => {
    setVisitorName(result.visitorName);
    setSurveyResponses(result.responses);
    setSurveyComplete(true);
    setSurveyTriggered(false);

    const submission: SurveySubmission = {
      visitorName: result.visitorName,
      consultantName: consultant.name,
      responses: result.responses.map((r) => ({
        questionId: r.questionId,
        answer: r.answer,
      })),
      timestamp: new Date().toISOString(),
    };

    try {
      await axios.post(`${API_BASE_URL}/survey/military`, submission);
    } catch (error) {
      console.error('Failed to save survey responses:', error);
    }
  };

  return (
    <div className="w-full">
      {surveyTriggered && !surveyComplete && (
        <SurveyPopup onComplete={handleSurveyComplete} />
      )}
      <MilitaryLandingContent
        consultant={consultant}
        visitorName={visitorName}
        surveyComplete={surveyComplete}
        surveyTriggered={surveyTriggered}
        surveyResponses={surveyResponses}
        onConnectClick={handleConnectClick}
      />
    </div>
  );
};

export default MilitaryLandingPage;

